import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../lib/ui";
import { getStoredRef, clearRef, ensureDeviceId } from "../lib/ref";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    (async () => {
      if (!m) { navigate("/login"); return; }
      try {
        const ref = getStoredRef();
        const { data } = await api.post("/auth/session", {
          session_id: decodeURIComponent(m[1]),
          device_id: ensureDeviceId(),
          ...(ref ? { ref } : {}),
        });
        if (ref) clearRef();
        await setSessionToken(data.token);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google");
      }
    })();
  }, [navigate, setSessionToken]);

  return <div className="min-h-screen flex items-center justify-center"><Spinner label="Validando tu acceso…" /></div>;
}
